import { Routes } from '@angular/router';

import { adminGuard, anonymousGuard, authGuard } from './core/auth/auth.guards';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login').then((m) => m.Login),
    canActivate: [anonymousGuard],
    data: { layout: 'blank', breadcrumbKey: 'auth.loginTitle', titleKey: 'auth.loginTitle' },
  },
  {
    path: 'patient',
    loadChildren: () =>
      import('./features/patient-portal/patient-portal.routes').then(
        (m) => m.PATIENT_PORTAL_ROUTES,
      ),
  },
  {
    path: 'admin',
    canActivateChild: [adminGuard],
    children: [
      {
        path: '',
        redirectTo: 'system/foods',
        pathMatch: 'full',
      },
      {
        path: 'system',
        loadChildren: () =>
          import('./features/admin/admin-system.routes').then((m) => m.ADMIN_SYSTEM_ROUTES),
        data: { breadcrumbKey: 'nav.breadcrumbs.system' },
      },
    ],
  },
  {
    path: '',
    canActivateChild: [authGuard],    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadComponent: () => import('./features/home/home').then((m) => m.Home),
        title: 'Inicio',
        data: { breadcrumbKey: 'nav.home', titleKey: 'nav.home' },
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./features/profile/profile.routes').then((m) => m.PROFILE_ROUTES),
        data: { breadcrumbKey: 'nav.breadcrumbs.profile' },
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
        data: { breadcrumbKey: 'nav.breadcrumbs.settings' },
      },
      {
        path: 'patients',
        loadChildren: () =>
          import('./features/patients/patients.routes').then(
            (m) => m.PATIENTS_ROUTES,
          ),
        // breadcrumb del padre vive aqui (es lo recomendado por NG-ZORRO
        // para rutas lazy-loaded).
        data: { breadcrumbKey: 'nav.breadcrumbs.patients' },
      },
      {
        path: 'medical-records',
        loadChildren: () =>
          import('./features/medical-records/medical-records.routes').then(
            (m) => m.MEDICAL_RECORDS_ROUTES,
          ),
        data: { breadcrumbKey: 'nav.breadcrumbs.medicalRecords' },
      },
      {
        path: 'agenda',
        loadChildren: () =>
          import('./features/agenda/agenda.routes').then((m) => m.AGENDA_ROUTES),
        data: { breadcrumbKey: 'nav.breadcrumbs.agenda' },
      },
      {
        path: 'foods',
        loadChildren: () =>
          import('./features/foods/foods.routes').then((m) => m.FOODS_ROUTES),
        data: { breadcrumbKey: 'nav.breadcrumbs.foods' },
      },
      {
        path: 'dietas',
        loadChildren: () =>
          import('./features/dietas/dietas.routes').then((m) => m.DIETAS_ROUTES),
        data: { breadcrumbKey: 'nav.breadcrumbs.dietas' },
      },
      {
        path: 'consultations',
        loadChildren: () =>
          import('./features/consultations/consultations.routes').then(
            (m) => m.CONSULTATIONS_ROUTES,
          ),
        data: { breadcrumbKey: 'nav.breadcrumbs.consultations' },
      },
      {
        path: 'menu',
        loadChildren: () =>
          import('./features/consultations/menu.routes').then((m) => m.MENU_ROUTES),
        data: { breadcrumbKey: 'nav.breadcrumbs.menu' },
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
